import vinrealSelectorVdp from './vinrealSelectorVdp';

const linkTypeMapping = {
	'vdp-slideshow': {
		page: {
			vinreal: vinrealSelectorVdp('click')
		},
		onclick: {
			onclick: '{inventoryType}:si:vehicle details:photo scroll',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:content:action:{nameplate}'
		}
	},
	'ford-download': {
		onclick: {
			onclick: 'brochures:pdf download',
			onclickLinkName: '{client}:brochures:pdf download'
		},
		page: {
			pageName: '{client}:brochures:pdf',
			siteSection: 'brochures',
			hierarchy: 'shopping tools:brochures',
			tool: 'event:pdf brochure',
			toolDescriptor: 'pdf'
		},
		user: {
			leadType: 'brochure:anonymous:pdf'
		},
		directCall: 'global-download'
	},
	'models-brochures': {
		onclick: {
			onclick: 'research models:brochure download',
			onclickLinkName: '{client}:research models'
		},
		page: {
			pageName: '{client}:research models',
			siteSection: 'research models',
			hierarchy: 'research models',
			tool: 'event:pdf brochure',
			toolDescriptor: 'research models:pdf brochure',
			variantName: 'vehicle-details-load'
		},
		user: {
			leadType: 'brochure:anonymous:pdf'
		},
		directCall: 'global-download'
	},
	incentive: {
		onclick: {
			onclickLinkName: '{client}:{inventoryType}:search inventory:'
		},
		page: {
			pageName: '{client}:special offers:request info'
		},
		directCall: 'vehicle-onclick'
	},
	'ev-charging-cta-explore-incentives': {
		onclick: {
			onclick: 'ev charging:content:explore incentives',
			onclickLinkName: '{client}:ev charging:content:action'
		}
	},
	'ev-charging-see-how-much-you-could-save': {
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:affordability',
			referredTo: 'fv:lp:fuel efficient:technologies:affordability',
			onclickLinkName: 'referral:exit'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ev-charging-get-more-charging-info': {
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:home charging',
			referredTo: 'fv:lp:fuel efficient:technologies:home charging',
			onclickLinkName: 'referral:exit'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ev-charging-see-our-multi-point-checklist': {
		onclick: {
			onclick: 'ev charging:content:schedule service',
			onclickLinkName: '{client}:ev charging:content:action'
		}
	},
	'ev-fake-thing': {
		fakething: {}
	},
	'ford-mobile-learn-more': {
		onclick: {
			onclick: 'referral:flmo:fp:rewards',
			onclickLinkName: 'referral:exit',
			referredTo: 'flmo:fp:rewards'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	referral: {
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclickLinkName: 'referral:exit'
		},
		directCall: 'referral-exit'
	},
	'specials-inforequest': {
		onclick: {
			onclick: 'service:parts:specials:content:request info',
			onclickLinkName: '{client}:service:parts:specials:content:action'
		}
	},
	'specials-emailafriend': {
		onclick: {
			onclick: 'service:parts:specials:content:email',
			onclickLinkName: '{client}:service:parts:specials:content:action'
		}
	},
	'video-popup': {
		onclick: {
			onclick: '{inventoryType}:si:vls:content:video play',
			onclickLinkName:
				'{client}:{inventoryType}:si:vls:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:new:vrfq:si:vin:video popup'
		},
		directCall: 'vehicle-onclick'
	},
	'video-tab': {
		onclick: {
			onclick: 'si:video',
			onclickLinkName:
				'{client}:{inventoryType}:vrfq:si:vin:video tab:{nameplate}'
		},
		page: {
			pageName: '{client}:new:vrfq:si:vin:video popup'
		},
		directCall: 'vehicle-onclick'
	},
	'windowsticker-vlp': {
		onclick: {
			onclickLinkName:
				'{client}:{inventoryType}:si:vls:view window sticker'
		},
		page: {
			tool: 'event:window sticker',
			hierarchy: 'shopping tools:search inventory:{inventoryType}',
			pageName: '{client}:{inventoryType}:si:vls',
			toolDescriptor: 'vls:window sticker'
		},
		event: {
			action: 'window sticker|tool'
		},
		directCall: 'window-sticker'
	},
	'windowsticker-vdp': {
		onclick: {
			onclick:
				'{inventoryType}:si:vehicle details:view window sticker:{nameplate}',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:view window sticker:{nameplate}'
		},
		page: {
			toolDescriptor: 'vehicle details:window sticker',
			tool: 'event:window sticker',
			hierarchy:
				'shopping tools:search inventory:{inventoryType}:{nameplate}',
			pageName: '{client}:{inventoryType}:si:vehicle details'
		},
		event: {
			action: 'window sticker|tool'
		},
		directCall: 'window-sticker'
	},
	'slideshow-prev': {
		onclick: {
			onclick: 'home:content:carousel scroll:left',
			onclickLinkName: '{client}:home:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:home',
			pageNameNoVehicle: '{client}:home',
			hierarchy: 'home',
			siteSection: 'home'
		}
	},
	'slideshow-next': {
		onclick: {
			onclick: 'home:content:carousel scroll:right',
			onclickLinkName: '{client}:home:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:home',
			pageNameNoVehicle: '{client}:home',
			hierarchy: 'home',
			siteSection: 'home'
		}
	},
	'staff-click': {
		onclick: {
			onclick: 'about us:meet our staff:photo click',
			onclickLinkName: '{client}:about us:meet our staff:content:action'
		}
	},
	'black-label-test-drive-navigator-click': {
		page: {
			pageName: '{client}:ownership:black label:test drive',
			siteSection: 'ownership',
			hierarchy:
				'shopping tools:test drive:black label:suv:lincoln navigator',
			pageNameNoVehicle: '{client}:ownership:black label:test drive'
		},
		vehicle: {
			modelYear: '2022',
			nameplate: 'lincoln navigator'
		}
	},
	'black-label-test-drive-aviator-click': {
		page: {
			pageName: '{client}:ownership:black label:test drive',
			siteSection: 'ownership',
			hierarchy:
				'shopping tools:test drive:black label:suv:lincoln aviator',
			pageNameNoVehicle: '{client}:ownership:black label:test drive'
		},
		vehicle: {
			modelYear: '2022',
			nameplate: 'lincoln aviator'
		}
	},
	'black-label-test-drive-nautilus-click': {
		page: {
			pageName: '{client}:ownership:black label:test drive',
			siteSection: 'ownership',
			hierarchy:
				'shopping tools:test drive:black label:suv:lincoln nautilus',
			pageNameNoVehicle: '{client}:ownership:black label:test drive'
		},
		vehicle: {
			modelYear: '2022',
			nameplate: 'lincoln nautilus'
		}
	},
	'black-label-test-drive-submit': {
		page: {
			pageName: '{client}:ownership:black label:test drive:thank you',
			siteSection: 'ownership',
			hierarchy: 'shopping tools:test drive:black label:suv',
			pageNameNoVehicle:
				'{client}:ownership:black label:test drive:thank you',
			tool: 'event:lead submitted',
			toolDescriptor: 'test drive:black label'
		},
		user: {
			leadType: 'test drive'
		},
		event: {
			action: 'lead submitted|test drive|tool'
		}
	},
	'black-label-navigator-themekit-learn-more': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-nautilus-themekit-learn-more': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln nautilus',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-themekit-learn-more': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-navigator-invitation-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator:invitation theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-navigator-centralpark-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator:central park theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-navigator-yachtclub-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator:yacht club theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-navigator-chalet-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln navigator:chalet theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-flight-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator:flight theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-destination-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator:destination theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-aviator-chalet-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln aviator:chalet theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-nautilus-redwood-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln nautilus:redwood theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-nautilus-chalet-theme-iball-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:explore theme:lincoln nautilus:chalet theme:iball click',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick: 'ownership:black label:content:search inventory',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click-navigator': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:search inventory:lincoln navigator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click-aviator': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:search inventory:lincoln aviator',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'black-label-search-inventory-click-nautilus': {
		page: {
			pageName: '{client}:ownership:black label',
			siteSection: 'ownership',
			hierarchy: 'ownership',
			pageNameNoVehicle: '{client}:ownership:black label'
		},
		onclick: {
			onclick:
				'ownership:black label:content:search inventory:lincoln nautilus',
			onclickLinkName: '{client}:ownership:black label:content:action'
		}
	},
	'lincoln-aviator-ev-gallery-scroll-left': {
		onclick: {
			onclick: 'hybrid ev:action:photo scroll:left',
			onclickLinkName: '{client}:hybrid ev:content:action'
		}
	},
	'lincoln-aviator-ev-gallery-scroll-right': {
		onclick: {
			onclick: 'hybrid ev:action:photo scroll:right',
			onclickLinkName: '{client}:hybrid ev:content:action'
		}
	},
	'lincoln-aviator-ev-gallery': {
		page: {
			pageName: '{client}:hybrid ev',
			siteSection: 'hybrid ev',
			hierarchy: 'hybrid ev',
			pageNameNoVehicle: '{client}:hybrid ev'
		},
		onclick: {
			onclick: 'hybrid ev:action:photo click',
			onclickLinkName: '{client}:hybrid ev:content:action'
		}
	},
	'why-buy-gallery': {
		onclick: {
			onclick: 'research models:content::photo click',
			onclickLinkName:
				'{client}:research models:why buy:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:research models:why buy',
			hierarchy: 'research models',
			siteSection: 'research models'
		}
	},
	'why-buy-navigator-2023-gallery-ext': {
		onclick: {
			onclick: 'research models:why buy:content:photo click:ext',
			onclickLinkName: '{client}:research models:why buy:content:action'
		},
		page: {
			pageName: '{client}:research models:why buy:lincoln navigator',
			hierarchy: 'research models:why buy',
			siteSection: 'research models',
			variantName: ''
		},
		vehicle: {
			modelYear: 2023,
			nameplate: 'lincoln navigator'
		}
	},
	'why-buy-navigator-2023-gallery-int': {
		onclick: {
			onclick: 'research models:why buy:content:photo click:int',
			onclickLinkName: '{client}:research models:why buy:content:action'
		},
		page: {
			pageName: '{client}:research models:why buy:lincoln navigator',
			hierarchy: 'research models:why buy',
			siteSection: 'research models',
			variantName: ''
		},
		vehicle: {
			modelYear: 2023,
			nameplate: 'lincoln navigator'
		}
	},
	'why-buy-nautilus-2023-gallery': {
		onclick: {
			onclick: 'research models:why buy:content:photo click',
			onclickLinkName: '{client}:research models:why buy:content:action'
		},
		page: {
			pageName: '{client}:research models:why buy:lincoln nautilus',
			hierarchy: 'research models:why buy',
			siteSection: 'research models',
			variantName: ''
		},
		vehicle: {
			modelYear: 2023,
			nameplate: 'lincoln nautilus'
		}
	},
	'why-buy-aviator-phev-gallery': {
		onclick: {
			onclick: 'research models:why buy:content:photo click',
			onclickLinkName: '{client}:research models:why buy:content:action'
		},
		page: {
			pageName: '{client}:research models:why buy:lincoln aviator phev',
			hierarchy: 'research models:why buy',
			siteSection: 'research models'
		},
		vehicle: {
			modelYear: 2023,
			nameplate: 'lincoln aviator phev'
		}
	},
	'why-buy-corsair-2023-gallery': {
		onclick: {
			onclick: 'research models:why buy:content:photo click',
			onclickLinkName: '{client}:research models:why buy:content:action'
		},
		page: {
			pageName: '{client}:research models:why buy:lincoln corsair',
			hierarchy: 'research models:why buy',
			siteSection: 'research models',
			variantName: ''
		},
		vehicle: {
			modelYear: 2023,
			nameplate: 'lincoln corsair'
		}
	},
	'why-buy-corsair-phev-2023-gallery': {
		onclick: {
			onclick: 'research models:why buy:content:photo click',
			onclickLinkName: '{client}:research models:why buy:content:action'
		},
		page: {
			pageName: '{client}:research models:why buy:lincoln corsair',
			hierarchy: 'research models:why buy',
			siteSection: 'research models',
			variantName: ''
		},
		vehicle: {
			modelYear: 2023,
			nameplate: 'lincoln corsair'
		}
	},
	'scroll-left-lincoln-aviator-gas-gallery': {
		onclick: {
			onclick: 'vehicle:action:filter:photo scroll:left',
			onclickLinkName: '{client}:vehicle:content:action:lincoln aviator'
		}
	},
	'scroll-right-lincoln-aviator-gas-gallery': {
		onclick: {
			onclick: 'vehicle:action:filter:photo scroll:right',
			onclickLinkName: '{client}:vehicle:content:action:lincoln aviator'
		}
	},
	'lincoln-aviator-gas-gallery': {
		onclick: {
			onclick: 'vehicle:action:filter:photo click',
			onclickLinkName: '{client}:vehicle:content:action:lincoln aviator'
		}
	},
	'apply-battery': {
		onclick: {
			onclick: 'battery service advice:content:apply now',
			onclickLinkName:
				'{client}:service:battery service advice:content:action'
		},
		referralExit: 'ford-pass-referral-exit-visa'
	},
	'apply-brakes': {
		onclick: {
			onclick: 'brake service advice:content:apply now',
			onclickLinkName:
				'{client}:service:brake service advice:content:action'
		},
		referralExit: 'ford-pass-referral-exit-visa'
	},
	'apply-general': {
		onclick: {
			onclick: 'general service advice:content:apply now',
			onclickLinkName:
				'{client}:service:general service advice:content:action'
		},
		referralExit: 'ford-pass-referral-exit-visa'
	},
	'apply-oil': {
		onclick: {
			onclick: 'oil change advice:content:apply now',
			onclickLinkName: '{client}:service:oil change advice:content:action'
		},
		referralExit: 'ford-pass-referral-exit-visa'
	},
	'apply-tires': {
		onclick: {
			onclick: 'tire service advice:content:apply now',
			onclickLinkName:
				'{client}:service:tire service advice:content:action'
		},
		referralExit: 'ford-pass-referral-exit-visa'
	},
	'blog-list-tag': {
		onclick: {
			onclick: 'about us:blog:content:tag',
			onclickLinkName: '{client}:about us:blog:content:action'
		}
	},
	'blog-post-tag': {
		onclick: {
			onclick: 'about us:blog:{pageTitle}:content:tag',
			onclickLinkName: '{client}:about us:blog:{pageTitle}:content:action'
		}
	},
	'coupon-scroll-battery': {
		onclick: {
			onclick: 'battery service advice:content:scroll offers',
			onclickLinkName:
				'{client}:service:battery service advice:content:action'
		}
	},
	'coupon-scroll-brakes': {
		onclick: {
			onclick: 'brake service advice:content:scroll offers',
			onclickLinkName:
				'{client}:service:brake service advice:content:action'
		}
	},
	'coupon-scroll-general': {
		onclick: {
			onclick: 'general service:content:scroll offers',
			onclickLinkName: '{client}:service:general service:content:action'
		}
	},
	'coupon-scroll-tires': {
		onclick: {
			onclick: 'tire service advice :content:scroll offers',
			onclickLinkName:
				'{client}:service:tire service advice:content:action'
		}
	},
	'coupon-scroll-oil': {
		onclick: {
			onclick: 'oil change advice:content:scroll offers',
			onclickLinkName: '{client}:service:oil change advice:content:action'
		}
	},
	'inventory-compare-remove': {
		onclick: {
			onclick: '{inventoryType}:si:vehicle compare:remove',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle compare:content:action'
		}
	},
	'print-battery': {
		onclick: {
			onclick: 'battery service advice:content:print offer',
			onclickLinkName:
				'{client}:service:battery service advice:content:action'
		}
	},
	'print-brakes': {
		onclick: {
			onclick: 'brake service advice:content:print offer',
			onclickLinkName:
				'{client}:service:brake service advice:content:action'
		}
	},
	'print-general': {
		onclick: {
			onclick: 'general service advice:content:print offer',
			onclickLinkName:
				'{client}:service:general service advice:content:action'
		}
	},
	'print-tires': {
		onclick: {
			onclick: 'tire service advice:content:print offer',
			onclickLinkName:
				'{client}:service:tire service advice:content:action'
		}
	},
	'print-oil': {
		onclick: {
			onclick: 'oil change advice:content:print offer',
			onclickLinkName: '{client}:service:oil change advice:content:action'
		}
	},
	'schedule-battery': {
		onclick: {
			onclick: 'battery service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:battery service advice:content:action'
		}
	},
	'schedule-brakes': {
		onclick: {
			onclick: 'brake service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:brake service advice:content:action'
		}
	},
	'schedule-general': {
		onclick: {
			onclick: 'general service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:general service advice:content:action'
		}
	},
	'schedule-oil': {
		onclick: {
			onclick: 'oil change advice:content:schedule service',
			onclickLinkName: '{client}:service:oil change advice:content:action'
		}
	},
	'schedule-tires': {
		onclick: {
			onclick: 'tire service advice:content:schedule service',
			onclickLinkName:
				'{client}:service:tire service advice:content:action'
		}
	},
	schedule_delivery_1: {
		onclick: {
			onclick: 'pickup and delivery:content:schedule service',
			onclickLinkName: '{client}:pickup and delivery:content:action'
		}
	},
	accordion_delivery_1: {
		onclick: {
			onclick: 'pickup and delivery:content:accordion:{title}:open',
			onclickLinkName: '{client}:pickup and delivery:content:action'
		}
	},
	'special-offers-print': {
		onclick: {
			onclick: 'offer:print',
			onclickLinkName: '{client}:special offers:print'
		}
	},
	pager: {
		onclick: {
			onclickLinkName: '{client}:home:content:action:{nameplate}'
		},
		page: {
			pageName: '{client}:home',
			pageNameNoVehicle: '{client}:home',
			hierarchy: 'home',
			siteSection: 'home'
		}
	},
	'black-label-pager': {
		onclick: {
			onclick: 'research models:content:photo click',
			onclickLinkName:
				'{client}:research models:black label:content:action'
		},
		page: {
			pageName: '{client}:research models:black label',
			pageNameNoVehicle: '{client}:research models:black label',
			hierarchy: 'research models',
			siteSection: 'research models'
		}
	},
	'payment-calculator': {
		onclick: {
			onclick:
				'{client}:{inventoryType}:si:vehicle details:payment calculator',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:payment calculator',
			tool: 'event:payment estimator',
			toolDescriptor: 'vehicle details:payment estimator'
		}
	},
	'finance-center': {
		onclick: {
			onclick: 'finance:finance department:content:accordion',
			onclickLinkName:
				'{client}:finance:finance department:content:action'
		}
	},
	'finance-application': {
		page: {
			pageName: '{client}:finance:get pre-approved',
			siteSection: 'finance',
			hierarchy: 'finance',
			tool: 'event:payment estimator',
			toolDescriptor: 'vehicle details:payment estimator'
		},
		onclick: {
			onclick: '{inventoryType}:si:vehicle details:payment calculator',
			onclickLinkName:
				'{client}:{inventoryType}:si:vehicle details:payment calculator'
		}
	},
	'ford-pass-apple-app-top': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:app download:apple:top',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-android-app-top': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:app download:google:top',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-apple-app-bottom': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:app download:apple:bottom',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-android-app-bottom': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:app download:google:bottom',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-learn-more': {
		onclick: {
			onclick: 'fordpass rewards credit card:content:learn more',
			onclickLinkName:
				'{client}:service:fordpass rewards credit card:content:action'
		},
		referralExit: 'ford-pass-referral-exit-visa'
	},
	'ford-pass-faq': {
		onclick: {
			onclick: 'fordpass rewards credit card:content:faq',
			onclickLinkName:
				'{client}:service:fordpass rewards credit card:content:action'
		},
		referralExit: 'ford-pass-referral-exit-faq'
	},
	'ford-pass-referral-exit-visa': {
		onclick: {
			onclick: 'referral:flmo:fp:visa',
			onclickLinkName: 'referral:exit',
			referredTo: 'flmo:fp:visa'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ford-pass-referral-exit-faq': {
		onclick: {
			onclick: 'referral:flmo:fp:faq',
			onclickLinkName: 'referral:exit',
			referredTo: 'flmo:fp:faq'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'collision-page-link': {
		onclick: {
			onclick: 'collision:content:{collisionClickType}',
			onclickLinkName: '{client}:service:collision:content:action'
		}
	},
	'click-to-call': {
		onclick: {
			onclick: 'help:click to call',
			onclickLinkName: '{client}:help:click to call'
		},
		event: {
			action: 'click to call'
		}
	},
	'shop-accessories': {
		onclick: {
			onclick: 'shop accessories:content:shop accessories',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'accessorize-my-ford': {
		onclick: {
			onclick: 'shop accessories:content:accessorize my ford',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'shop-interior': {
		onclick: {
			onclick: 'shop accessories:content:shop interior',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'shop-wheels': {
		onclick: {
			onclick: 'shop accessories:content:shop wheels',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'shop-electronics': {
		onclick: {
			onclick: 'shop accessories:content:shop electronics',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'shop-bed-products': {
		onclick: {
			onclick: 'shop accessories:content:shop bed products',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'shop-exterior-products': {
		onclick: {
			onclick: 'shop accessories:content:shop exterior products',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'shop-trailer-towing': {
		onclick: {
			onclick: 'shop accessories:content:shop trailer towing',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'accessories-referral-exit'
	},
	'shop-apply-now': {
		onclick: {
			onclick: 'shop accessories:content:apply now',
			onclickLinkName: '{client}:service:shop accessories:content:action'
		},
		referralExit: 'ford-pass-referral-exit-visa'
	},
	'accessories-referral-exit': {
		onclick: {
			onclick: 'referral:gfa:home',
			onclickLinkName: 'referral:exit',
			referredTo: 'gfa:home'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ford-blue-advantage-search-inventory': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:content:search inventory',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:content:action'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		}
	},
	'lincoln-cpo-mbg-download': {
		onclick: {
			onclick: 'cpo overview:mbgt:brochure download:pdf brochure',
			onclickLinkName: '{client}:cpo overview:mbgt:download'
		},
		page: {
			pageName: 'dc:cpo overview:mbgt:download',
			tool: 'event:pdf brochure',
			toolDescriptor: '200 point inspection checklist'
		}
	},
	'lincoln-cpo-mbg-general-click': {
		onclick: {
			onclick: 'cpo overview:mbgt:content:click',
			onclickLinkName: '{client}:cpo overview:mbgt:content:action:click'
		}
	},
	'lincoln-cpo-download': {
		onclick: {
			onclick: 'cpo overview:brochure download:pdf brochure',
			onclickLinkName: '{client}:cpo overview:download'
		},
		page: {
			pageName: 'dc:cpo overview:download',
			tool: 'event:pdf brochure',
			toolDescriptor: '200 point inspection checklist'
		}
	},
	'lincoln-cpo-overview-general-click': {
		onclick: {
			onclick: 'cpo overview:content:click',
			onclickLinkName:
				'{client}:used:si:cpo overview:content:action:click'
		}
	},
	'ford-blue-advantage-search-download-gold': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:gold certified',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'ford-blue-advantage-search-download-blue': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:blue certified',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'ford-blue-advantage-search-download-172': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:172 point checklist',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'ford-blue-advantage-search-download-139': {
		onclick: {
			onclick:
				'used:si:cpo overview blue advantage:brochure download:139 point checklist',
			onclickLinkName:
				'{client}:used:si:cpo overview blue advantage:download'
		},
		page: {
			pageNameNoVehicle: '{client}:used:si:cpo overview blue advantage'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'fordprotect-page-download-premium-care': {
		onclick: {
			onclick: 'fordprotect:brochure download:premiumcare',
			onclickLinkName: '{client}:service:fordprotect:download'
		},
		page: {
			pageNameNoVehicle: '{client}:service:fordprotect'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'fordprotect-page-download-premium-maintenance': {
		onclick: {
			onclick: 'fordprotect:brochure download:premium maintenance',
			onclickLinkName: '{client}:service:fordprotect:download'
		},
		page: {
			pageNameNoVehicle: '{client}:service:fordprotect'
		},
		event: {
			action: 'pdf brochure'
		},
		directCall: 'global-download'
	},
	'fordprotect-page-download-premiumcare-brochure': {
		onclick: {
			onclick: 'fordprotect:brochure download:premiumcare',
			onclickLinkName: '{client}:service:fordprotect:download'
		},
		page: {
			pageNameNoVehicle: '{client}:service:fordprotect',
			tool: 'event:pdf brochure',
			toolDescriptor: 'fordprotect:pdf brochure'
		},
		event: {
			action: 'pdf brochure'
		}
	},
	'fordprotect-page-download-premium-maintenance-brochure': {
		onclick: {
			onclick: 'fordprotect:brochure download:premium maintenance',
			onclickLinkName: '{client}:service:fordprotect:download'
		},
		page: {
			pageNameNoVehicle: '{client}:service:fordprotect',
			tool: 'event:pdf brochure',
			toolDescriptor: 'fordprotect:pdf brochure'
		},
		event: {
			action: 'pdf brochure'
		}
	},
	'fordprotect-page-download-premiumcare-ev-brochure': {
		onclick: {
			onclick: 'fordprotect:brochure download:premiumcare:ev',
			onclickLinkName: '{client}:service:fordprotect:download'
		},
		page: {
			pageNameNoVehicle: '{client}:service:fordprotect',
			tool: 'event:pdf brochure',
			toolDescriptor: 'fordprotect:pdf brochure'
		},
		event: {
			action: 'pdf brochure'
		}
	},
	'fordprotect-page-download-premium-maintenance-ev-brochure': {
		onclick: {
			onclick: 'fordprotect:brochure download:premium maintenance:ev',
			onclickLinkName: '{client}:service:fordprotect:download'
		},
		page: {
			pageNameNoVehicle: '{client}:service:fordprotect',
			tool: 'event:pdf brochure',
			toolDescriptor: 'fordprotect:pdf brochure'
		},
		event: {
			action: 'pdf brochure'
		}
	},
	'ford-parts-page-enrolled': {
		onclick: {
			onclick: 'referral:fpol:find dealer:vanity landing',
			onclickLinkName: 'referral:exit',
			referredTo: 'fpol:find dealer:vanity landing'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ford-parts-page-not-enrolled': {
		onclick: {
			onclick: 'referral:generic',
			onclickLinkName: 'referral:exit',
			referredTo: 'generic'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'ford-service-price-see-pricing': {
		onclick: {
			onclick: 'service pricing:content:see service pricing',
			onclickLinkName:
				'{client}:service:service pricing:content:service pricing'
		}
	},
	'ford-service-price-schedule-service': {
		onclick: {
			onclick: 'schedule service:content:schedule service',
			onclickLinkName:
				'{client}:service:schedule service:content:schedule service'
		}
	},
	'ford-service-price-see-all-offers': {
		onclick: {
			onclick: 'service pricing:content:see all offers',
			onclickLinkName:
				'{client}:service:service pricing:content:see all offers'
		}
	},
	'ford-service-price-oil-changes': {
		onclick: {
			onclick: 'service pricing:content:oil change',
			onclickLinkName:
				'{client}:service:service pricing:content:oil change'
		}
	},
	'ford-service-price-tires': {
		onclick: {
			onclick: 'service pricing:content:tires',
			onclickLinkName: '{client}:service:service pricing:content:tires'
		}
	},
	'ford-service-price-battery': {
		onclick: {
			onclick: 'service pricing:content:battery',
			onclickLinkName: '{client}:service:service pricing:content:battery'
		}
	},
	'ford-service-price-breaks': {
		onclick: {
			onclick: 'service pricing:content:brakes',
			onclickLinkName: '{client}:service:service pricing:content:brakes'
		}
	},
	'ford-adchoices': {
		onclick: {
			onclick: 'help:aboutads',
			onclickLinkName: '{client}:help:aboutads'
		},
		page: {
			pageName: '{client}:help:aboutads'
		}
	},
	'ford-pass-learn-about-the-rewards-visa': {
		onclick: {
			onclick:
				'service:fordpass landingpage:content:learn more:credit card',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-learn-about-the-rewards': {
		onclick: {
			onclick: 'service:fordpass landingpage:content:learn more:rewards',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'ford-pass-learn-about-the-app': {
		onclick: {
			onclick: 'service:fordpass landingpage:content:learn more:app',
			onclickLinkName:
				'{client}:service:fordpass landingpage:content:action'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-range-and-batteries': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:range and batteries',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:range and batteries'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-make-the-switch': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:make the switch',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:make the switch'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-home-charging': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:home charging',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:home charging'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-public-charging': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:public charging',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:public charging'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-bluecruise-learn-more': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:blue cruise',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:blue cruise'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-bluecruise-content-area': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:blue cruise',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:blue cruise'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-maintenance-guides': {
		directCall: 'referral-exit',
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:maintenance guides',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:maintenance guides'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-discover-fordpass-app': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:charging tools:fordpass app',
			onclickLinkName: 'referral:exit',
			referredTo:
				'fv:lp:fuel efficient:technologies:charging tools:fordpass app'
		}
	},
	'alias-sitebuilder-electric-vehicles-1-explore-owner-support': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:charging tools:explore owner support',
			onclickLinkName: 'referral:exit',
			referredTo:
				'fv:lp:fuel efficient:technologies:charging tools:explore owner support'
		}
	},
	'lincoln-competitve-compare-navigator-search': {
		onclick: {
			onclick: 'competitive compare:content:search inventory',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln navigator'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln navigator'
		}
	},
	'lincoln-competitve-compare-navigator-more': {
		onclick: {
			onclick: 'competitive compare:content:learn more',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln navigator'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln navigator'
		}
	},
	'lincoln-competitve-compare-corsair-search': {
		onclick: {
			onclick: 'competitive compare:content:search inventory',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln corsair'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln corsair'
		}
	},
	'lincoln-competitve-compare-corsair-more': {
		onclick: {
			onclick: 'competitive compare:content:learn more',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln corsair'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln corsair'
		}
	},
	'lincoln-competitve-compare-aviator-search': {
		onclick: {
			onclick: 'competitive compare:content:search inventory',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln aviator'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln aviator'
		}
	},
	'lincoln-competitve-compare-aviator-more': {
		onclick: {
			onclick: 'competitive compare:content:learn more',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln aviator'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln aviator'
		}
	},
	'lincoln-competitive-compare-nautilus-search': {
		onclick: {
			onclick: 'competitive compare:content:search inventory',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln nautilus'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln nautilus'
		}
	},
	'lincoln-competitive-compare-nautilus-more': {
		onclick: {
			onclick: 'competitive compare:content:learn more',
			onclickLinkName:
				'{client}:competitive compare:content:action:lincoln nautilus'
		},
		vehicle: {
			modelYear: '2023',
			nameplate: 'lincoln nautilus'
		}
	},
	'ev-lightning-learn-more': {
		onclick: {
			onclick: 'referral:fv:vehicle:home:ford lightning',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:vehicle:home:ford lightning'
		},
		directCall: 'referral-exit',
		vehicle: {
			modelYear: '2024',
			nameplate: 'ford lightning'
		}
	},
	'ev-lightning-view-inventory': {
		onclick: {
			onclick: 'ev vhp:content:view inventory',
			onclickLinkName: '{client}:ev vhp:content:action'
		}
	},
	'ev-lightning-search-inventory': {
		onclick: {
			onclick: 'ev vhp:content:search inventory',
			onclickLinkName: '{client}:ev vhp:content:action'
		}
	},
	'ev-lightning-charging-info': {
		onclick: {
			onclick: 'referral:get more charging info',
			onclickLinkName: 'referral:exit',
			referredTo: 'get more charging info'
		},
		directCall: 'referral-exit',
		vehicle: {
			modelYear: '2024',
			nameplate: 'ford lightning'
		}
	},
	'ev-lightning-explore-home-charging': {
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:home charging',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:home charging'
		},
		directCall: 'referral-exit',
		vehicle: {
			modelYear: '2024',
			nameplate: 'ford lightning'
		}
	},
	'ev-lightning-explore-power': {
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:intelligent back-up power',
			onclickLinkName: 'referral:exit',
			referredTo:
				'fv:lp:fuel efficient:technologies:intelligent back-up power'
		},
		directCall: 'referral-exit',
		vehicle: {
			modelYear: '2024',
			nameplate: 'ford lightning'
		}
	},
	'ev-lightning-explore-public-charging': {
		onclick: {
			onclick:
				'referral:fv:lp:fuel efficient:technologies:public ev charging',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:public ev charging'
		},
		directCall: 'referral-exit',
		vehicle: {
			modelYear: '2024',
			nameplate: 'ford lightning'
		}
	},
	'ev-lightning-explore-see-how-much-you-could-save': {
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:affordability',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:affordability'
		},
		directCall: 'referral-exit',
		vehicle: {
			modelYear: '2024',
			nameplate: 'ford lightning'
		}
	},
	'ev-overview-all-incentives': {
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		},
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:affordability',
			onclickLinkName: 'referral:exit',
			referredTo: 'fv:lp:fuel efficient:technologies:affordability'
		}
	},
	'ev-overview-explore-incentives': {
		onclick: {
			onclick: 'ev lifestyle:content:explore incentives',
			onclickLinkName: '{client}:ev lifestyle:content:action'
		}
	},
	'ev-overview-explore-charging': {
		onclick: {
			onclick: 'ev lifestyle:content:explore charging',
			onclickLinkName: '{client}:ev lifestyle:content:action'
		}
	},
	'ev-overview-explore-cta-f150': {
		onclick: {
			onclick: 'ev lifestyle:content:explore f150',
			onclickLinkName: '{client}:ev lifestyle:content:action'
		}
	},
	'ev-overview-explore-cta-mache': {
		onclick: {
			onclick: 'ev lifestyle:content:explore mache',
			onclickLinkName: '{client}:ev lifestyle:content:action'
		}
	},
	'ev-overview-see-how-much-you-could-save': {
		onclick: {
			onclick: 'referral:fv:lp:fuel efficient:technologies:affordability',
			referredTo: 'fv:lp:fuel efficient:technologies:affordability',
			onclickLinkName: 'referral:exit'
		},
		directCall: 'referral-exit',
		event: {
			action: 'brand referral'
		}
	},
	'ev-overview-get-more-ownership-info': {
		onclick: {
			onclick: 'ev lifestyle:content:ownership info',
			onclickLinkName: '{client}:ev lifestyle:content:action'
		}
	},
	'ev-overview-contact-us': {
		onclick: {
			onclick: 'ev lifestyle:content:contact us',
			onclickLinkName: '{client}:ev lifestyle:content:action'
		}
	},
	'ford-mobile-service': {
		onclick: {
			onclick: 'service:mobileservice:content:schedule service',
			onclickLinkName: '{client}:service:mobileservice:content:action'
		}
	},
	'ncc-vinless-card-mache': {
		onclick: {
			onclick: '{inventoryType}:si:vls:content:model e card',
			onclickLinkName:
				'{client}:{inventoryType}:si:vls:content:action:ford mustang mach-e'
		}
	},
	'ncc-vinless-card-lightning': {
		onclick: {
			onclick: '{inventoryType}:si:vls:content:model e card',
			onclickLinkName:
				'{client}:{inventoryType}:si:vls:content:action:ford f150 lightning'
		}
	},
	'alias-sitebuilder-2023-ford-mach-e-1-get-more-charging-info': {
		onclick: {
			onclick: 'referral:get more charging info',
			referredTo: 'get more charging info',
			onclickLinkName: 'referral:exit'
		},
		event: {
			action: 'brand referral'
		},
		vehicle: {
			modelYear: '{modelYear}',
			nameplate: 'ford mustang mach-e'
		},
		directCall: 'referral-exit'
	},
	'alias-sitebuilder-2023-ford-mach-e-1-view-details': {
		onclick: {
			onclick: 'ev vhp:content:view-details',
			onclickLinkName: '{client}:ev vhp:content:action'
		}
	},
	'model-e-buy-now-srp': {
		onclick: {
			onclick:
				'{inventoryType}:si:{vehiclePageType}:content:model e buy now',
			onclickLinkName:
				'{client}:{inventoryType}:si:{vehiclePageType}:content:action:{nameplate}',
			referredTo: 'model e buy now'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'model-e-buy-now-vdp': {
		onclick: {
			onclick: '{inventoryType}:si:{vehiclePageType}:model e buy now',
			onclickLinkName:
				'{client}:{inventoryType}:si:{vehiclePageType}:content:action:{nameplate}',
			referredTo: 'model e buy now'
		},
		event: {
			action: 'brand referral'
		},
		directCall: 'referral-exit'
	},
	'pickup-and-delivery-cta': {
		page: {
			pageName: '{client}:ownership:pickup and delivery:contact us',
			hierarchy: 'ownership:contact us'
		},
		directCall: 'global-overlay'
	}
};

export default linkTypeMapping;
